import styled, { css } from 'styled-components'
import type { ComponentsTheme } from '../../providers/ComponentsThemeProvider'
import type { Props } from './types'

type ContainerProps = {
  $isLoading?: Props['isLoading']
}

export const Container = styled.div<ContainerProps>(
  /* NOTE: No need for relative position when !isLoading since it may break all kind of tooltips. */
  ({ $isLoading }) => css`
    height: inherit;
    flex: 1;

    ${$isLoading &&
    css`
      position: relative;
    `}
  `,
)

const getBackground = ({ theme }: { $variant: Props['variant'] } & { theme: ComponentsTheme }) => {
  if (theme.automated?.styles?.colorBackground) {
    return theme.automated?.styles.colorBackground
  }

  return 'var(--bg-primary)'
}

export const OverlayContainer = styled.div<
  { $variant: Props['variant'] } & { $loaderPosition: Props['loaderPosition'] }
>`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;

  padding: 16px;

  ${({ $loaderPosition }) =>
    $loaderPosition === 'center' &&
    css`
      align-items: center;
    `}
  ${({ $loaderPosition }) =>
    $loaderPosition === 'top' &&
    css`
      align-items: flex-start;
    `}

  justify-content: center;
  z-index: 1;

  width: 100%;
  height: 100%;

  background: ${getBackground};

  ${({ $variant }) =>
    $variant === 'transparent' &&
    css`
      opacity: 0.8;
    `}
`
